import types from "rdx/modules/preferredPartners/types";
import createAction from "rdx/utils/createAction";

export default {
  getPreferredPartnersAdmin: (payload) => createAction(types.GET_PREFERRED_PARTNERS_ADMIN, payload),
  setPreferredPartnersAdmin: (payload) => createAction(types.SET_PREFERRED_PARTNERS_ADMIN, payload),
  deletePreferredPartner: (payload) => createAction(types.DELETE_PREFERRED_PARTNER, payload),
  createPreferredPartner: (payload) => createAction(types.CREATE_PREFERRED_PARTNER, payload),
  setPreferredPartnersAutocompleteSuggestions: (payload) =>
    createAction(types.SET_PREFERRED_PARTNERS_AUTOCOMPLETE_SUGGESTIONS, payload),
  // INSERTION_PT (for script, do not remove)
};
